import React from 'react';

import Header from '/react4xp/components/Header'

import '/react4xp/shared/css/normalize.min.css'
import '/react4xp/shared/css/bootstrap-grid.min.css'
import '/react4xp/shared/css/balloon.min.css'
import '/react4xp/shared/scss/main.scss'

const HeaderComponent = (props: any) => {
    return (
        <Header {...props} />
    )
}

export default HeaderComponent;
